import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  DxAccordionModule,
  DxButtonGroupModule,
  DxButtonModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxHtmlEditorModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxPopupModule,
  DxProgressBarModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTabsModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeListModule,
} from 'devextreme-angular';
import { PipesModule } from './pipes/pipes.module';
import { MergeQueueGuardDirectiveModule } from '../lib/directives/merge-queue-guard.directive.module';

@NgModule({
  declarations: [],
  exports: [
    PipesModule,
    MergeQueueGuardDirectiveModule,
    CommonModule,
    RouterModule,
    DxButtonGroupModule,
    DxButtonModule,
    DxLoadIndicatorModule,
    DxFormModule,
    DxDateBoxModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTabsModule,
    DxAccordionModule,
    DxDataGridModule,
    DxToolbarModule,
    DxTreeListModule,
    DxTagBoxModule,
    DxHtmlEditorModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxTextBoxModule,
    DxProgressBarModule,
    DxFileUploaderModule,
    DxTextAreaModule,
    DxFormModule,
    DxListModule,
    DxTooltipModule,
  ],
  imports: [MergeQueueGuardDirectiveModule],
})
export class SharedModule {}
